// extracted by mini-css-extract-plugin
module.exports = {"btn":"UnassignDevice_btn__16Oqm"};